<template>
  <div v-if="active" class="loginContainer">
  	
  	<i class="fa fa-user"></i>

  	<div class="title">
  		Bygg din tavelvägg beta
  	</div>

  	<div class="description"> 
  		Välkommen till betaverisonen utav bygg din tavelvägg, var god skriv in ditt namn nedan. 
  	</div>

    <form v-on:submit="setName">
    	<div class="input">
    		<input v-model="name" type="text">
    	</div>

    	<div v-on:click="setName" class="button"> SKICKA </div>
      <input type="submit" style="position: absolute; left: -9999px"/>
    </form>

  </div>
  
</template>

<script>

export default {
  data: function(){ 
    return{
    	name: "",
    	active: false
    }
  },

  methods: {

  	setName(e){

  		var Cookies = require('js-cookie');
  		
  		if(this.name){
  			Cookies.set('beta_name', this.name, { expires: 999, path: '/' });
  			this.active = false;
  		}
  		else{
  			alert("Var god fyll i ditt namn.");
  		}

      e.preventDefault();
      return false;
  		
  	}

  },

  mounted(){

  	var Cookies = require('js-cookie');

  	var name = Cookies.get('beta_name');

  	if(typeof name == 'undefined'){
  		this.active = true;
  	}

  }

}
</script>

<style>

.loginContainer{
	text-align: center;
	position:absolute;
	top:0;
	padding-top: 10%;
	left: 0;
	background-color: rgba(255, 255, 255, 0.93);
	width:100%;
	height:100%;
	z-index: 99999;

  /* Mobile */
  @media screen and (max-width: 779px) {
    padding-top: 0%;
  }

	i{
		font-size: 63px;
    	color: #a8a8a8;

       @media screen and (max-width: 779px) {
        display: none;
       }
	}

	.title{
		font-size: 20px;
		font-family: "Raleway", "Helvetica Neue", "Helvetica", Arial, sans-serif;
		text-transform: uppercase;
		font-weight: 600;
		margin: 10px 0;
	}

  .button{
    background: black;
    color: white;
  }

	.input{
		max-width: 500px;
		text-align: center;
		margin: auto;

		input{
			width: 100%;
			margin-top: 15px;
		}
	}

}

</style>



// WEBPACK FOOTER //
// LoginTest.vue?17dadf6c